import moment from 'moment';

const state = {
    record: {},
    channels: [],
    channelNames: [],
    internalLinks: null,
    channelCredentials: {},
    categories: [],
    media: {},
    mediaType: {},
    user: null,
    wpCredentialsAreValid: false,
    swCredentialsAreValid: false,
    selections: [],
    isAdmin: false,
    hasMagazines: false,
    submitAttempted: false
};

const getters = {
    getIsAdmin(state) {
        return state.isAdmin
    },
    getHasMagazines(state) {
        return state.hasMagazines
    },
    getWpCredentialsAreValid(state) {
        return state.wpCredentialsAreValid;
    },
    getSwCredentialsAreValid(state) {
        return state.swCredentialsAreValid;
    },
    getUser(state) {
        return state.user
    },
    getMediaType(state) {
        return state.mediaType
    },
    getChannels(state) {
        return state.channels
    },
    getSelections(state) {
        return state.selections;
    },
    getImage(state) {
        return state.image
    },
    getInternalLinks(state) {
        if(state.internalLinks == null){
            state.internalLinks = {};
            mutations.getInternalLinks(state);
        }
        return state.internalLinks;
    },
    getChannelNames(state) {
        let array = [];
        state.channels.forEach(channel => {
            array.push(channel.channel)
        })
        return array;
    },
    getChannelCredentials(state) {
        return state.channelCredentials;
    },
    getRecord(state) {
        return state.record;
    },
    getCategories(state) {
        return state.categories;
    },
    getSubmitAttempted(state) {
        return state.submitAttempted;
    }
};

const mutations = {
    setIsAdmin(state, user) {
        state.isAdmin = user
    },
    setHasMagazines(state, hasMagazines) {
        state.hasMagazines = hasMagazines
    },
    setSubmitAttempted(state, value) {
        state.submitAttempted = value;
    },
    setWpCredentialsAreValid(state, bool) {
        state.wpCredentialsAreValid = bool;
    },
    setSwCredentialsAreValid(state, bool) {
        state.swCredentialsAreValid = bool;
    },
    setSelections(state, selections) {
        state.selections = selections;
    },
    setInternalLinks(state, internalLinks) {
        state.internalLinks = internalLinks;
    },
    setUser(state, user) {
        state.user = user
    },
    setMedia(state, payload) {
        state.media = payload.media;
        state.mediaType = payload.mediaType;
    },
    getRecord(state) {
        axios.get(`/backend/news_hubs/${state.record.id}`).then(res => {
            state.record.client_has_app = res.data.client_has_app
        })
    },
    getBlogCategories(state) {
        axios.post('/backend/news_hub/get-blog-categories', {
            client_id: state.record.client_id
        }).then(res => {
            state.categories = res.data
        })
    },
    setClientId(state, id) {
        state.record.client_id = id;
    },
    setChannels(state, payload) {
        state.channels = payload
        state.channels.forEach(item => {
            item.publish_at = moment(item.publish_at).format('YYYY-MM-DDTHH:mm')
        })
    },
    removeImage(state, payload) {
        if (payload.type === 'content') {
            state.channels[payload.index].content_url = null;
        } else {
            state.channels[payload.index].preview_image_url = null;
        }
    },
    async addChannel(state, payload) {

        let channel = null;

        if (payload.channel) {
            channel = payload.channel;
        } else if (payload.mediaType && payload.mediaType.belongs_to !== 'news_blog') {
            channel = payload.mediaType.belongs_to
        }

        /* SMKIEB-3286
        if (state.channels.length > 0 && payload.channel === 'magazine') {
            if (confirm('Ein WKZ-Trendblog kann nur alleinstehend genutzt werden. Sind Sie sicher, dass Sie fortfahren und die anderen Kanäle löschen möchten?')) {
                state.channels.length = 0;
            } else {
                return;
            }
        }*/

        let newChannel = {
            client_id: state.record.client_id,
            foreign_id: null,
            news_hub_id: state.record.id,
            channel: channel,
            category_id: state.categories[0],
            publish_later: false,
            publish_at: null,
            notify_via: '',
            tagged_users: [],
            notification_sent: false,
            chat_notification: null,
            teaser_text: null,
            news_content: null,
            preview_image_url: null,
            additional_content: [],
            send_info_send_type: 'app_user',
            send_info_send_to_selection_id: 0,
            send_info_send_file_info: 'Noch nicht gestartet',
        }

        if (state.media.id) {
            axios.get(`/api/content-hub/media/${state.media.id}/${payload.channel ? payload.channel : payload.mediaType.id}`).then(res => {

                if (['wordpress', 'shopware'].includes(channel) && !!res.data.content_url) {
                    if (res.data.content_url.includes('.mov') || res.data.content_url.includes('.mp4')) {
                        newChannel.preview_image_url = res.data.preview_image_url;
                        newChannel.content_url = res.data.content_url
                    } else {
                        newChannel.preview_image_url = res.data.content_url;
                    }
                } else {
                    newChannel.content_url = res.data.content_url;
                }

                newChannel.news_content = res.data.news_content
                state.channels.push(newChannel);
            })
        } else {
            state.channels.push(newChannel);
        }
    },
    async getChannels(state) {
        await axios.get(`/backend/news_hub_transmissions/${state.record.id}/${state.record.client_id}`).then(res => {
            mutations.setChannels(state, res.data.transmissions)
            state.channels.forEach(item => {
                state.channelNames.push(item.channel);
                item.publish_at = moment(item.publish_at).format('YYYY-MM-DDTHH:mm')
            })
        })
    },
    getChannelCredentials(state) {
        axios.get(`/backend/client_api_credentials/${state.record.client_id}`).then(res => {
            state.channelCredentials = res.data
            state.channelCredentials.client_id = state.record.client_id

            if (state.channelCredentials.wp_url) {
                mutations.setWpCredentialsAreValid(state, true)
            }
            if (state.channelCredentials.sw_url) {
                mutations.setSwCredentialsAreValid(state, true);
            }
        })
    },
    getInternalLinks(state) {
        axios.get(`/backend/news_hub/internal_links/${state.record.client_id}`).then(res => {
            mutations.setInternalLinks(state,res.data);
        })
    },
    async firstInit(state, record) {
        state.record = record;
        mutations.getInternalLinks(state);
        await mutations.getChannels(state);
        mutations.getChannelCredentials(state);

        if (state.channelNames.includes('wordpress') || state.channelNames.includes('shopware')) {
            mutations.getBlogCategories(state)
        }
    },
    removeChannel(state, payload) {
        if (confirm('Bist du dir sicher?')) {
            if (payload.id) {
                axios.delete(`/backend/news_hub_transmissions/${payload.id}`)
            }
            state.channels.splice(payload.index, 1);
            return true;
        }

        return false;
    },
}
const actions = {};

export default {
    state,
    getters,
    mutations,
    actions
}
